"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var BaseFirebaseStorage = require("./BaseFirebaseStorage");
module.exports = /*#__PURE__*/function (_BaseFirebaseStorage) {
  (0, _inherits2["default"])(FirebaseStorageClient, _BaseFirebaseStorage);
  var _super = _createSuper(FirebaseStorageClient);
  // Firebase Admin SDK and Client SDK provides different means to manage files
  // when it comes to copying/moving, there is no efficient way to do this
  // directly from client so we only limit the client code to storageUpload and storageDelete for efficiency
  // the rest is delegated to the server side implementation

  function FirebaseStorageClient(firebase, pathConfig, baseUrl, plainToClassHook, classToPlainHook, classTransformOptions) {
    var _this;
    (0, _classCallCheck2["default"])(this, FirebaseStorageClient);
    _this = _super.call(this, firebase, pathConfig, baseUrl, plainToClassHook, classToPlainHook, classTransformOptions);
    _this.storageRef = firebase.storage().ref();
    return _this;
  }
  (0, _createClass2["default"])(FirebaseStorageClient, [{
    key: "uploadFile",
    value: function () {
      var _uploadFile = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(fullPath, file, metadata, progressCallback) {
        var fileRef, _yield$Promise$all, _yield$Promise$all2, downloadUrl, _metadata;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.uploadFileInternal(fullPath, file, metadata, progressCallback);
            case 2:
              fileRef = _context.sent;
              if (!fileRef) {
                _context.next = 12;
                break;
              }
              _context.next = 6;
              return Promise.all([fileRef.getDownloadURL(), this.getFileMetadata(fullPath)]);
            case 6:
              _yield$Promise$all = _context.sent;
              _yield$Promise$all2 = (0, _slicedToArray2["default"])(_yield$Promise$all, 2);
              downloadUrl = _yield$Promise$all2[0];
              _metadata = _yield$Promise$all2[1];
              _metadata.downloadUrl = downloadUrl;
              return _context.abrupt("return", _metadata);
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function uploadFile(_x, _x2, _x3, _x4) {
        return _uploadFile.apply(this, arguments);
      }
      return uploadFile;
    }()
  }, {
    key: "getFileMetadata",
    value: function () {
      var _getFileMetadata = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(fullPath) {
        var fileRef;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              fileRef = this.refFromPath(fullPath);
              this.log("getFileMetadata client");
              _context2.next = 4;
              return fileRef.getMetadata();
            case 4:
              return _context2.abrupt("return", _context2.sent);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getFileMetadata(_x5) {
        return _getFileMetadata.apply(this, arguments);
      }
      return getFileMetadata;
    }()
  }, {
    key: "uploadFileInternal",
    value: function uploadFileInternal(fullPath, file, metadata) {
      var _this2 = this;
      var progressCallback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
      return new Promise(function (resolve, reject) {
        var uploadRef = _this2.refFromPath(fullPath);
        _this2.log("uploadFileInternal: fullPath = ", fullPath, ", metadata = ", metadata, ", file = ", file);
        var uploadTask = uploadRef.put(file, metadata);
        var totalSizeInBytes = -1;
        uploadTask.on('state_changed', function (snapshot) {
          var progress = snapshot.bytesTransferred / snapshot.totalBytes * 100 || 0;
          totalSizeInBytes = snapshot.totalBytes;
          progressCallback(progress, snapshot.state, uploadTask);
        }, function (error) {
          if (error && error.code === "storage/canceled") {
            progressCallback(0, "cancelled", uploadTask);
            resolve(null);
          } else {
            progressCallback(0, "error", uploadTask);
            reject(error);
          }
        }, function () {
          progressCallback(100, "completed", uploadTask);
          resolve(uploadRef);
        });
      });
    }
  }, {
    key: "deleteFile",
    value: function () {
      var _deleteFile = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(fullPath) {
        var ref;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              ref = this.refFromPath(fullPath);
              return _context3.abrupt("return", ref["delete"]());
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function deleteFile(_x6) {
        return _deleteFile.apply(this, arguments);
      }
      return deleteFile;
    }()
  }, {
    key: "refFromPath",
    value: function refFromPath(path) {
      return this.storageRef.child(path);
    }
  }]);
  return FirebaseStorageClient;
}(BaseFirebaseStorage);